import { ReactElement } from 'react'
import { useAppSelector } from 'src/store/hooks'
import { selectUseGroupsV2 } from 'src/v3/settings/settings.slice'
import GroupsV4 from './index'
import GroupsV2 from '../groups-v2'

export default function GroupsWrapper(): ReactElement {
  let useGroupsV2 = useAppSelector(selectUseGroupsV2)
  return useGroupsV2 ? <GroupsV2 /> : <GroupsV4 />
}
